'use client';

import React, { useState } from 'react';

import styles from '@/styles/PropertyLineage.module.scss';

export interface LineageMoreProps {
  /** How many additional value groups are hidden. */
  hidden: number
  /** The hidden value-group blocks, revealed on click. */
  children: React.ReactNode
}

/** Reveal the value groups beyond the first few shown in a lineage panel.
 *
 * The most-corroborated values lead; the long tail of alternate spellings
 * stays behind this toggle so a property with dozens of name variants doesn't
 * flood the panel. Block-level on purpose — the inline `ExpandList` used in the
 * value cell doesn't fit a stack of grouped rows. */
export function LineageMore({ hidden, children }: LineageMoreProps) {
  const [open, setOpen] = useState(false);
  if (open) {
    return <>{children}</>;
  }
  return (
    <button type="button" className={styles.moreButton} onClick={() => setOpen(true)}>
      +{hidden} more {hidden === 1 ? 'value' : 'values'}
    </button>
  );
}
